module.exports = __webpack_public_path__ + "static/media/infogestion.68c25c14.png";